import React, { Component } from "react";
import { Menu } from "semantic-ui-react";
import { connect } from "react-redux";
import { updateMultiServiceAppointmentConfirmationModalVisibility } from "../../../actions/menu";
import { Modal } from "semantic-ui-react";
import { forceValidation } from "../validMeReact";
import { saveBooking, updateBooking } from "../../../actions/booking";
import { updateRecurringAppointmentConfirmationModalVisibility } from "../../../actions/menu";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  toApiDateTime,
  convertApiUtcToLocalMoment,
  convertTimeFromApi,
  convertDateTimeFromApi
} from "../../../utils/helpers";

@connect(mapStateToProps)
export default class MultiServiceAppointmentConfirmationModal extends Component {
  constructor(props) {
    super(props);
  }

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  handleSaveClick = () => {
    let {
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
      appointmentStepDataBeforeUserHasMadeAnyChanges,
      customerProfileData,
      apiCustomerProfileData,
      currentBookingId,
      appointmentStepData,
      advancedAppointmentStepData,
      closeAppWhenRecursiveAppointmentModalCloses,
      gotValidOffer,
      isMultiServiceAppointment,
      advancedAppointmentStepDataFromLastSave
    } = this.props;
    let {
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedDate,
      selectedTime,
      originalSelectedDateOnceAppointmentWasOpened,
      originalSelectedTimeOnceAppointmentWasOpened
    } = appointmentStepData;
    let areThereErrors = forceValidation(
      null,
      null,
      "secondStepAdvancedAppointment"
    );
    let areThereErrorsTwo = forceValidation(null, null, "firstStepAppointment");
    let cb = () => {
      let event = new CustomEvent("messageFromUsToParent", {
        detail: {
          action: "refresh"
        }
      });
      window.dispatchEvent(event);
      this.closeApp();
    };
    if (!areThereErrors && !areThereErrorsTwo) {
      let oldStartTime = null;
      let currentStartTime = null;
      if (
        selectedTimeBeforeWeOverrodeRecurringAppointment &&
        selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
      ) {
        oldStartTime = toApiDateTime(
          selectedDateBeforeWeOverrodeRecurringAppointment,
          selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
          appointmentStepData.timeList
        );
      }

      currentStartTime = toApiDateTime(
        appointmentStepData.multiServiceList[0].selectedDate,
        appointmentStepData.multiServiceList[0].selectedTime.stringValue,
        appointmentStepData.timeList
      );

      let startTimeBeforeChanges = toApiDateTime(
        appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
          .selectedDate,
        appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
          .selectedTime.stringValue,
        appointmentStepData.timeList
      );

      let startTimeAfterChanges = toApiDateTime(
        appointmentStepData.multiServiceList[0].selectedDate,
        appointmentStepData.multiServiceList[0].selectedTime.stringValue,
        appointmentStepData.timeList
      );

      let draggedAndDroppedTimes = toApiDateTime(
        appointmentStepData.originalSelectedDateOnceAppointmentWasOpened,
        appointmentStepData.originalSelectedTimeOnceAppointmentWasOpened
          .stringValue,
        appointmentStepData.timeList
      );

      if (
        appointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot &&
        startTimeAfterChanges != draggedAndDroppedTimes
      ) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            null,
            null,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else if (startTimeBeforeChanges == startTimeAfterChanges) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            null,
            null,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            null,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            null,
            null,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    }
  };

  handleCancel = () => {
    let visible = false;
    this.props.dispatch(
      updateMultiServiceAppointmentConfirmationModalVisibility(visible)
    );
  };

  render() {
    let {
      MultiServiceAppointmentModal,
      MultiserviceModalConfirmationText,
      Confirm
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    let {
      multiserviceAppointmentConfirmationModalVisible,
      savingBooking,
      loadingBooking
    } = this.props;

    if (!multiserviceAppointmentConfirmationModalVisible) {
      return "";
    }

    let confirmButtonClass = "ui button send_btn discard-button";
    if (savingBooking || loadingBooking) {
      confirmButtonClass += " disabled";
    }

    return (
      <Modal
        className="bookingdetails-model save-recursive-appointment-confirmation transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="save-box save-recurring">
            <section className="header">
              <button
                type="button"
                className="close_button"
                onClick={this.closeApp}
              ></button>
              {MultiServiceAppointmentModal}
              <p className="save_text">{MultiserviceModalConfirmationText}</p>
            </section>
            <section className="save_box_buttons">
              <div
                className={confirmButtonClass}
                onClick={this.handleSaveClick}
              >
                {Confirm}
              </div>
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    multiserviceAppointmentConfirmationModalVisible:
      state.menuReducer.multiserviceAppointmentConfirmationModalVisible,
    savingBooking: state.bookingReducer.savingBooking,
    currentMenu: state.menuReducer.currentMenu,
    loadingBooking: state.bookingReducer.loadingBooking,
    globalErrorMessage: state.globalErrorReducer.message,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    checkoutPreviousMenu: state.menuReducer.checkoutPreviousMenu,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    currentBookingId: state.bookingReducer.currentBookingId,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    appointmentStepDataBeforeUserHasMadeAnyChanges:
      state.appointmentStepReducer
        .appointmentStepDataBeforeUserHasMadeAnyChanges,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    customerProfileData: state.customerProfileReducer.customerProfileData
  };
}
